/** A single navigable item in the dashboard sidebar. */
export interface DashboardMenuItem {
  label: string;
  /** Absolute router path (without leading slash). */
  route: string;
  /** Font Awesome icon classes. */
  icon: string;
}

/** A labelled group of sidebar items. */
export interface DashboardMenuGroup {
  title: string;
  items: DashboardMenuItem[];
}

/**
 * Post-login navigation for the customer dashboard.
 * Routes map 1:1 to the children registered under the dashboard layout route.
 */
export const DASHBOARD_MENU: DashboardMenuGroup[] = [
  {
    title: 'Main',
    items: [
      { label: 'Dashboard', route: 'dashboard', icon: 'fa-solid fa-table-columns' },
    ],
  },
  {
    title: 'Account',
    items: [
      { label: 'My Profile', route: 'userdetailPage', icon: 'fa-regular fa-user' },
      { label: 'Wallet', route: 'recharge-wallet', icon: 'fa-solid fa-wallet' },
    ],
  },
  {
    title: 'Orders & History',
    items: [
      { label: 'Product Orders', route: 'customer-product-order-history', icon: 'fa-solid fa-box-open' },
      { label: 'Recharge History', route: 'customer-transactions-history', icon: 'fa-solid fa-clock-rotate-left' },
      { label: 'Chat History', route: 'customer-chat-order-history', icon: 'fa-regular fa-comments' },
      { label: 'Call History', route: 'customer-call-order-history', icon: 'fa-solid fa-phone' },
    ],
  },
  {
    title: 'More',
    items: [
      { label: 'Offers', route: 'my-offers', icon: 'fa-solid fa-tags' },
      { label: 'Support Chat', route: 'support-chat', icon: 'fa-regular fa-life-ring' },
    ],
  },
];

/** Flat list of all dashboard routes — handy for title lookups. */
export const DASHBOARD_ITEMS: DashboardMenuItem[] = DASHBOARD_MENU.flatMap((g) => g.items);
